/// <amd-module name="Repos/PullRequestMentionAutocomplete/PullRequestAutocompleteCommand" />
import * as Resources from "Repos/PullRequestMentionAutocomplete/Resources";
import { IMarkdownToolbarCommand } from "VSS/Features/MarkdownEditor/Commands/Toolbar";
import { insertText } from "VSS/Features/MarkdownEditor/Formatting/Common";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult } from "VSS/Features/MarkdownEditor/Formatting/Contracts";
import { IIconProps } from "VSSUI/Icon";

export class PullRequestAutocompleteCommand implements IMarkdownToolbarCommand {
    private pullRequestCharacter = "!";
    public id = "pr-autocomplete";
    public iconProps: IIconProps = { iconName: "BranchPullRequest" };
    public text = Resources.PullRequestToolbarCommandText;
    public rank = 110;

    public formatText = (formattingArgs: IMarkdownFormattingArgs, errorHandler: (error: Error) => void): IMarkdownFormattingResult => {
        return insertText(formattingArgs, this.pullRequestCharacter);
    };
}
